module.exports = __webpack_public_path__ + "img/blue_055.673ba452.png";